import { useMutation } from '@tanstack/react-query';

import { getSecurityBidAsk, getSecurityCS, getSecurityInfo, getSecurityMarketData } from '../../../../api';

export const useSecurityInfo = () =>
  useMutation({
    mutationKey: ['getSecurityInfo'],
    mutationFn: (securityKey: string) => getSecurityInfo(securityKey),
    onError: (error) => {
      console.error('Ошибка получения информации о ценной бумаге:', error);
    },
  });

export const useSecurityBidAsk = () =>
  useMutation({
    mutationKey: ['getSecurityBidAsk'],
    mutationFn: (securityKey: string) => getSecurityBidAsk(securityKey),
    onError: (error) => {
      console.error('Ошибка получения данных стакана:', error);
    },
  });

export const useSecurityCS = () =>
  useMutation({
    mutationKey: ['getSecurityCS'],
    mutationFn: (securityKey: string) => getSecurityCS(securityKey),
    onError: (error) => {
      console.error('Ошибка получения данных CS:', error);
    },
  });

export const useSecurityMarketData = () =>
  useMutation({
    mutationKey: ['getSecurityMarketData'],
    mutationFn: (securityKey: string) => getSecurityMarketData(securityKey),
    onError: (error) => {
      console.error('Ошибка получения рыночных данных:', error);
    },
  });
